import {getLocaleCodes} from '../../common/i18n/locales';
import {defaultRegion} from '../../common/utils';

interface DateTimeFormatter {
    longDate: Intl.DateTimeFormat;
    shortDate: Intl.DateTimeFormat;
    longMonthDay: Intl.DateTimeFormat;
    shortMonthDay: Intl.DateTimeFormat;
    longDateTime: Intl.DateTimeFormat;
    shortDateTime: Intl.DateTimeFormat;
    shortTime: Intl.DateTimeFormat;
    nanoTime: Intl.DateTimeFormat;
}

const dateTimeFormatters = getLocaleCodes().reduce(
    (acc: Record<string, DateTimeFormatter>, code: string) => ({
        ...acc,
        [code]: {
            // December 20, 2012
            longDate: new Intl.DateTimeFormat(code, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            }),
            // 4/30/2021
            shortDate: new Intl.DateTimeFormat(code, {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
            }),
            // December 20
            longMonthDay: new Intl.DateTimeFormat(code, {month: 'long', day: 'numeric'}),
            // 12/20
            shortMonthDay: new Intl.DateTimeFormat(code, {month: 'numeric', day: 'numeric'}),
            // April 27, 2021, 3:03 PM
            longDateTime: new Intl.DateTimeFormat(code, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
            }),
            // 4/30/2021, 2:30 PM
            shortDateTime: new Intl.DateTimeFormat(code, {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
            }),
            // 12:30
            shortTime: new Intl.DateTimeFormat(defaultRegion, {hour: 'numeric', minute: 'numeric'}),
            // 30:58
            nanoTime: new Intl.DateTimeFormat(defaultRegion, {
                minute: 'numeric',
                second: 'numeric',
            }),
        },
    }),
    {},
);

export const format = (
    date: string | number,
    formatCode: keyof DateTimeFormatter,
    locale = defaultRegion,
) => dateTimeFormatters[locale][formatCode].format(new Date(date));
